export default __webpack_public_path__ + "6926457c85f0047fbcb990aef0ee921c.jpg";